import './shares-style.scss'

import classNames from 'classnames'
import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share'

import { ReactComponent as Iconlink } from '@/assets/icons/crypto_icons_link.svg'

const Shares = ({ title }) => {
  const [show, setShow] = useState(false)
  const shareUrl =
    typeof window !== 'undefined'
      ? window.location.origin + window.location.pathname
      : ''
  const showCopied = () => {
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, 1000)
  }
  return (
    <div className="share-container">
      <FacebookShareButton
        url={shareUrl}
        quote={title}
        className="share-button"
      >
        <FacebookIcon
          size={40}
          iconFillColor="transparent"
          bgStyle={{
            fill: 'transparent',
          }}
        />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title} className="share-button">
        <TwitterIcon
          size={40}
          iconFillColor="transparent"
          bgStyle={{
            fill: 'transparent',
          }}
        />
      </TwitterShareButton>

      <TelegramShareButton
        url={shareUrl}
        title={title}
        className="share-button"
      >
        <TelegramIcon
          size={40}
          iconFillColor="#0058AA"
          bgStyle={{
            fill: 'transparent',
          }}
        />
      </TelegramShareButton>
      <div className="share-link">
        <CopyToClipboard text={shareUrl} onCopy={showCopied}>
          <Iconlink width={25} height={22} />
        </CopyToClipboard>
        <div
          className={classNames({
            'share-copied': true,
            show,
          })}
        >
          <p>Copied</p>
        </div>
      </div>
    </div>
  )
}

export default Shares
